import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteSubscriber, getSubscriberList, getfaqlist, updateSubscriberStatus } from '../../actions/users';
import { FaTrash } from 'react-icons/fa6';

const SubscriberList = () => {


    const navigate = useNavigate();


    const [userList, setUserList] = useState([]);
    const [userListBackUp,setUserListBackup] = useState([]);
    const [searchText, setSearchText] = useState("");
    

    const getSubscribersList = async () => {
		var subscriberData = await getSubscriberList({searchText});
        
		if (subscriberData.userValue.data) {
			
			setUserList(subscriberData.userValue.data);
            setUserListBackup(subscriberData.userValue.data);
		}	
	}

	const add = async () => {
      
        let data = userList.some((val)=>val.maySent)
        if(data){
            navigate("/subscriberadd");
        }else{
            toast.error('Please select At least one Mail',1000);
        }
	}

	const handleChangemaysent = async (event) => {
		let {id , checked} = event.target;
		
		let handlemaychange = await updateSubscriberStatus({email : id , maySentChecked : checked});
		if (handlemaychange) {
			
			// toast.success('Success...',1000);
            getSubscribersList();
		}
		// setTimeout(()=>{
		// 	window.location.reload();
		// },2000)
	}

	useEffect(() => {
		getSubscribersList();
	}, [searchText]);

    const removeSubscriber = async (subscriberId) => {
        let sendData = {
            subscriberId:  subscriberId
        };
        let resp = await deleteSubscriber(sendData);
        if(resp?.userValue?.sucess){
            toast.success('Subscriber deleted succesfully',1000);
            getSubscribersList();
        }
        
    }

        const columns = [
           
            {
    
                key: "Email",
                name: "Email",
                // // className: "tokenId",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) =>
                    <p>{row.email}</p>
            },
            {
    
                key: "Action",
                name: "Action",
                // className: "tokenBid",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) => {
                    return (
                        <Fragment>
                            {row && 
                            <>
                            <Form.Check type="checkbox" name={row._id} id={row.email} checked={row.maySent} onChange={(event) =>{ handleChangemaysent(event)}}/>
                            <button className='btn btn-danger btn-sm ms-2' onClick={() => { removeSubscriber(row?._id) }} type='button'><FaTrash /></button> 
                            </>
                            }
                        </Fragment>
                    );
                }
    
            },
        ];

        // useEffect(()=>{
        //     let instUserList = userListBackUp;
        //     if(searchText){
        //         instUserList = userListBackUp.filter((check)=>check?.email?.includes(searchText));
        //     }
        //     setUserList([...instUserList]);
        // },[searchText,userListBackUp]);

    return (
        <Layout>
            <div className="subscriberlist">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h1 className="pagehead mb-0">Subscriber Lists</h1>
                    <Link to="/subscriberadd" className="btn sitebtn" onClick={add}>Send News Letter</Link>
                </div>
                <div className="cardbox">
                    <div className="tablebox">
                        <Form.Control type="text" placeholder="Filter in records" onChange={(e)=>setSearchText(e?.target?.value)} value={searchText} />
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={userList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            noDataComponent={<p className='py-5'>No data</p>}
                           persistTableHead 
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default SubscriberList;